import React from "react";
import { Spinner as DeprecatedSpinner } from "@chakra-ui/react";

import { colours } from "@shared/ui.design-system";

type Props = {
  showMask?: boolean;
};

export const DeprecatedDrawerLoadingMask: React.FC<Props> = ({
  showMask = false
}) => {
  return showMask ? (
    <div
      data-testid="drawer-loading-mask"
      style={{
        position: "absolute",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        zIndex: 2000
      }}
    >
      <span
        style={{
          position: "absolute",
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",
          backgroundColor: colours.secondary.light,
          opacity: 0.75
        }}
      />
      <DeprecatedSpinner
        color={colours.accent.strong}
        size="xl"
        thickness="4px"
      />
    </div>
  ) : null;
};
